export default __webpack_public_path__ + "static/media/relationship-work.f291135d.jpg";